import { tv } from '@change/ds-utils';

/**
 * Styles for terms agreement checkbox wrapper
 *
 * Overrides the design system's BaseCheckbox default size (h-4 w-4) to match Figma design (24x24)
 * Uses descendant selectors to target the checkbox indicator div inside the React Aria label
 */
export const termsAgreementStyles = tv({
	slots: {
		checkboxWrapper: [
			// Override checkbox size from 16x16 (h-4 w-4) to 24x24 (h-6 w-6)
			// Targets: <div> (checkbox indicator) inside <label data-rac="">
			'[&_[data-rac]>div:first-of-type]:h-6 [&_[data-rac]>div:first-of-type]:w-6',
			// Override checkbox border radius to 4px (rounded-sm)
			'[&_[data-rac]>div:first-of-type]:rounded-sm',
			// Center the check icon using flexbox
			'[&_[data-rac]>div:first-of-type]:flex [&_[data-rac]>div:first-of-type]:items-center [&_[data-rac]>div:first-of-type]:justify-center',
			// Remove default margin-top to allow proper centering
			'[&_[data-rac]>div:first-of-type]:mt-0',
			// Override SVG checkmark size (14x14 default, scale proportionally for 24x24 box)
			// Using 16x16 SVG to fit nicely centered in 24x24 box
			'[&_[data-rac]>div:first-of-type>svg]:h-4 [&_[data-rac]>div:first-of-type>svg]:w-4',
		],
	},
});
